import React from 'react' 
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import NumberPicker from './NumberPicker'
import Badge from 'react-bootstrap/Badge'
import ReadMore from './ReadMore'

const UNIVERSE = 'rgba(28,35,43,.15)'

export default class TicketGroupCell extends React.Component { 

	constructor(props) { 
		super(props)
		this.state = { 
			value: '0'
		}
	}

	getCost() { 
		if (this.props.ticketGroup.cost == 0) { 
			return "Free"
		} else { 
			const cost = this.props.ticketGroup.display_cost
			return "$" + cost.toString()
		}
	}

	getSoldOut() { 
		if (this.props.ticketGroup.sold_out === true) { 
			return  <Badge pill variant="danger" style={{marginBottom:10}}>Sold out</Badge>
		} else { 
			return null
		}
	}

	getLimit() { 
		if (this.props.ticketGroup.max_tickets_per_order === undefined) { 
			return 1
		} else { 
			return this.props.ticketGroup.max_tickets_per_order
		}
	}

	getNumberPicker() { 
		if (this.props.ticketGroup.sold_out === false) { 
			return <Col xs={3}>
						<NumberPicker onChange={(val)=> this.handleNumerPickerChange(val)}
							max={this.getLimit()}
						/>
					</Col>
		} else { 
			return null
		}
	}

	handleNumerPickerChange(val) {
		this.props.onChange(val)
	}

	render() { 
		return ( 
			<div>
			<Card style={{marginBottom: 10, boxShadow: ` 0px 0px 10px ${UNIVERSE}`}}> 
				<Card.Body>
				<Row>
					<Col >
						<Card.Title>{this.props.ticketGroup.title}</Card.Title>
						<p>{this.getCost()}</p>
						{this.getSoldOut()}
					</Col>


					{this.getNumberPicker()}
				</Row>
					<Card.Text>
					<ReadMore
					lines={2}>
					  {this.props.ticketGroup.description}
					</ReadMore>
					 </Card.Text>
					 </Card.Body>
				</Card>
			</div>

			)
	}
}